import { render, staticRenderFns } from "./PromoBarB.vue?vue&type=template&id=3a192829&scoped=true&"
import script from "./PromoBarB.vue?vue&type=script&lang=js&"
export * from "./PromoBarB.vue?vue&type=script&lang=js&"
import style0 from "./PromoBarB.vue?vue&type=style&index=0&id=3a192829&prod&lang=css&"
import style1 from "./PromoBarB.vue?vue&type=style&index=1&id=3a192829&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a192829",
  null
  
)

export default component.exports